import React from 'react'
import PropTypes from 'prop-types'
import Button from '../../ui/Button'
import WarningModal from './WarningModal'
import { pluralize } from '../../../utils/textHelpers'

const BODY_CLASS = 'tw:m-0! tw:text-sm tw:text-gray-700 tw:text-center'
const STRONG_CLASS = 'tw:font-semibold'

const StatusChangeModal = ({ isOpen, statusName, issuesCount, fromLabel, toLabel, onCancel, onConfirm }) => {
  const footer = (
    <>
      <Button variant="neutral" onClick={onCancel}>Annuler</Button>
      <Button variant="primary" onClick={onConfirm}>Confirmer</Button>
    </>
  )

  return (
    <WarningModal footer={footer} isOpen={isOpen} title="Changement de catégorie" onClose={onCancel}>
      <p className={BODY_CLASS}>
        {`${pluralize(issuesCount, 'alerte')} `}
        <span className={STRONG_CLASS}>{`« ${fromLabel} / ${statusName} »`}</span>
        {issuesCount > 1 ? ' vont basculer en ' : ' va basculer en '}
        <span className={STRONG_CLASS}>{`« ${toLabel} / ${statusName} »`}</span>
      </p>
    </WarningModal>
  )
}

StatusChangeModal.propTypes = {
  fromLabel: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  issuesCount: PropTypes.number.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  statusName: PropTypes.string.isRequired,
  toLabel: PropTypes.string.isRequired
}

export default StatusChangeModal
